import { isDarkTheme } from '@/constants/Colors';

// Neutral surfaces keep native goal controls independent of accent colors.
export function macGoalAppearance(theme) {
  return isDarkTheme(theme) ? {
    surface: '#252527', field: '#1C1C1E', hover: '#353537', border: '#414144',
    focus: '#98989D', text: '#F5F5F7', secondary: '#AEAEB2',
    action: '#F5F5F7', actionText: '#202022',
  } : {
    surface: '#FFFFFF', field: '#F7F7F8', hover: '#EEEEF0', border: '#E3E3E7',
    focus: '#8E8E93', text: '#1D1D1F', secondary: '#6E6E73',
    action: '#262628', actionText: '#FFFFFF',
  };
}
